import Breadcrumbs from "../../components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { Button, Col, Container, FormGroup, Input, Label, Row } from "reactstrap"
import { withTranslation } from "react-i18next"
import Select from "react-select"
import { get, handleApiError, post } from "../../helpers/api_helper"
import toastr from "toastr";
import { getUserRoleFromToken } from "../../helpers/auth_token_helper"

const Schedule = props => {
  const [selectedBag, setSelectedBag] = useState(null);
  const [bags, setBags] = useState([]);
  const [schedule, setSchedule] = useState({});
  const [loading, setLoading] = useState(false);
  const bagIri= '/v1/api/bags/';
  const role = getUserRoleFromToken();

  const handleToggle = (day) => {
    setSchedule({
      ...schedule,
      [day]: { ...schedule[day], active: !schedule[day].active },
    });
  };

  const handleChange = (day, field, value) => {
    setSchedule({
      ...schedule,
      [day]: { ...schedule[day], [field]: value },
    });
  };

  const hasError = (data, field) => {
    if (!data.active) return false;

    switch (field) {
      case 'quantity':
        return Number(data.quantity) <= 0;
      case 'startTime':
        return !data.startTime;
      case 'endTime':
        return !data.endTime;
      default:
        return false;
    }
  };

  const hasScheduleError = Object.values(schedule).some((data) => {
    if (!data.active) return false;

    return (
      Number(data.quantity) <= 0 ||
      !data.startTime ||
      !data.endTime
    );
  });

  const handleSelectBag = (value) => {
    const selected = bags.find(bag => bag.value === value);
    setSelectedBag(selected || null);
  };

  const fetchBags = async () => {
    const responseBags = await get('bags');
    if (200 === responseBags.status && responseBags.data['hydra:member'].length > 0) {
      const newBags = responseBags.data['hydra:member'].map(item => ({
        label: item.name,
        value: item.id
      }));
      setBags(newBags);
      //setSelectedBag(newBags[0]);
    }
  }

  const fetchAvailabilities = async () => {
    if (!selectedBag) {
      return;
    }

    const responseAvailabilities = await get('bag-availabilities', {'bag': selectedBag.value});
    if (200 === responseAvailabilities.status) {
      setDataSchedule(responseAvailabilities.data['hydra:member'])
    }
  }

  const setDataSchedule = (data) => {
    const newSchedule = {
      lundi: { active: false, quantity: 0, startTime: "", endTime: "" },
      mardi: { active: false, quantity: 0, startTime: "", endTime: "" },
      mercredi: { active: false, quantity: 0, startTime: "", endTime: "" },
      jeudi: { active: false, quantity: 0, startTime: "", endTime: "" },
      vendredi: { active: false, quantity: 0, startTime: "", endTime: "" },
      samedi: { active: false, quantity: 0, startTime: "", endTime: "" },
      dimanche: { active: false, quantity: 0, startTime: "", endTime: "" },
    };
    data.forEach(item => {
      const dayMap = {
        1: 'lundi',
        2: 'mardi',
        3: 'mercredi',
        4: 'jeudi',
        5: 'vendredi',
        6: 'samedi',
        7: 'dimanche',
      };
      const day = dayMap[item.dayOfWeek];
      if (day) {
        newSchedule[day] = {
          active: true,
          quantity: item.quantity,
          startTime: item.startCollectionTime,
          endTime: item.endCollectionTime,
        };
      }
    });
    setSchedule(newSchedule);
  }

  const handleValidateSchedule = async () => {
    if ('seller' === role) {
      return false;
    }

    setLoading(true);
    const dayMapReverse = {
      lundi: 1,
      mardi: 2,
      mercredi: 3,
      jeudi: 4,
      vendredi: 5,
      samedi: 6,
      dimanche: 7,
    };

    const formattedData = Object.entries(schedule)
      .filter(([_, data]) => data.active)
      .map(([day, data]) => ({
        dayOfWeek: dayMapReverse[day],
        startCollectionTime: data.startTime,
        endCollectionTime: data.endTime,
        quantity: parseInt(data.quantity),
      }));

    try {

      const responsePost = await post("bag-availabilities", {
        'bag' : bagIri + selectedBag.value,
        'schedule': formattedData,
        'source': 'schedule'
      });

      if (200 === responsePost.status) {
        toastr.success('Vos modifications ont été enregistrées avec succès.');
      }
    } catch (error) {
      handleApiError(error.response.data)
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchBags();
  }, [])

  useEffect(() => {
    fetchAvailabilities();
  }, [selectedBag]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Planificateur des collectes")}
                       breadcrumbItem={props.t("Planificateur des collectes")} />

          <div className="mt-4">
            <div className="alert alert-info">
              <p className="mb-2">
                Gérer facilement la disponibilité de vos Paniers pour chaque jour de la semaine.
              </p>
              <ul className="mb-0">
                <li className="d-flex align-items-center my-2"><i className="bx bx-calendar-check font-size-18" />  <strong className="mx-2">Activez/désactivez</strong> la collecte pour chaque jour via le <span className="badge bg-success">bouton switch</span>.</li>
                <li className="d-flex align-items-center my-2"><i className="bx bx-poll font-size-18" />  <strong className="mx-2">Définissez la quantité</strong> de Paniers qui vous estimez être disponible ce jour.</li>
                <li className="d-flex align-items-center my-2"><i className="bx bx-time font-size-18" />  <strong className="mx-2">Indiquez l'heure de début et de fin de la collecte.</strong></li>
              </ul>
            </div>

            <div className="card shadow-sm p-3 mb-4">
              <h5 className="text-dark"><i className="bx bx-check-circle text-success"></i> Exemple d'utilisation</h5>
              <p className="mb-1">
                <i className="bx bx-check text-primary me-2"></i>
                <strong>Lundi</strong> → Collecte <span className="badge bg-info">activée</span>, <strong>10 Paniers</strong> disponibles entre <span className="text-primary">18:00 et 20:00</span>.
              </p>
              <p>
                <i className="bx bx-x text-danger me-2"></i>
                <strong>Dimanche</strong> → Collecte <span className="badge bg-danger">désactivée</span> (aucun panier disponible).
              </p>
            </div>

            <div className="alert alert-light border-start border-primary ps-3">
              <i className="bx bx-bulb text-primary me-2"></i>
              <strong>Astuce :</strong> Ajustez ces paramètres à tout moment pour optimiser la gestion des stocks et éviter les pertes !
            </div>
          </div>

          <div className="d-flex justify-content-end align-items-center mb-5">
            <span className="text-info mx-3 fw-bold">Sélectionner un Panier</span>
            <select
              value={selectedBag?.value || ''}
              onChange={e => handleSelectBag(e.target.value)}
              className="form-select w-75"
            >
              <option value="">-- Choisir un panier --</option>
              {bags.map(bag => (
                <option key={bag.value} value={bag.value}>
                  {bag.label}
                </option>
              ))}
            </select>
          </div>

          {
            selectedBag ?
              <div>
                {Object.entries(schedule).map(([day, data]) => (
                  <div className="py-2 border-1 border-bottom" key={day}>
                    <Row className="align-items-center">
                      <Col md={4}>
                        <h6 className="text-capitalize mb-1">{day}</h6>
                        <div>
                          {data.active ? (
                            <span className="badge bg-info">Collecte disponible</span>
                          ) : (
                            <span className="badge bg-danger">Pas de collecte disponible</span>
                          )}
                        </div>
                      </Col>
                      <Col md={2}>
                        <div
                          className="form-check form-switch form-switch-md mb-3"

                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customSwitchsizemd"
                            checked={data.active}
                            onChange={() => handleToggle(day)}
                            disabled={role==='seller'}
                            readOnly={role==='seller'}
                          />
                        </div>
                      </Col>
                      <Col md={2}>
                        <FormGroup>
                          <Label>Quantité</Label>
                          <Input
                            type="number"
                            min="0"
                            value={data.quantity}
                            onChange={(e) => handleChange(day, "quantity", e.target.value)}
                            style={{ width: '80px' }}
                            disabled={!data.active || role==='seller'}
                            readOnly={role==='seller'}
                          />
                          {hasError(data, 'quantity') && (
                            <div className="text-danger mt-1 small">
                              Merci de renseigner la quantité.
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={2}>
                        <FormGroup>
                          <Label>Début</Label>
                          <Input
                            type="time"
                            value={data.startTime}
                            onChange={(e) => handleChange(day, "startTime", e.target.value)}
                            style={{
                              width: '100px'
                            }}
                            disabled={!data.active || role==='seller'}
                            readOnly={role==='seller'}
                          />
                          {hasError(data, 'startTime') && (
                            <div className="text-danger mt-1 small">
                              Merci de renseigner l'heure de début.
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={2}>
                        <FormGroup>
                          <Label>Fin</Label>
                          <Input
                            type="time"
                            value={data.endTime}
                            onChange={(e) => handleChange(day, "endTime", e.target.value)}
                            style={{
                              width: '100px'
                            }}
                            disabled={!data.active || role==='seller'}
                            readOnly={role==='seller'}
                          />
                          {hasError(data, 'endTime') && (
                            <div className="text-danger mt-1 small">
                              Merci de renseigner l'heure de fin.
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                ))}

                {
                  ('admin' === role || 'manager' === role) && (
                    <div className="text-center my-4">
                      <Button
                        color="primary"
                        className="w-50 d-flex align-items-center justify-content-center rounded-5 mx-auto"
                        onClick={handleValidateSchedule}
                        disabled={loading || hasScheduleError}
                      >
                        <i className="bx bx-calendar-check me-2"></i>
                        {loading ? "Enregistrement..." : "Enregistrer le Calendrier"}
                      </Button>
                    </div>
                  )
                }
              </div>
              :
              <p className="fw-bold justify-content-center text-center mt-3">
                Sélectionner un panier depuis la liste déroulante pour afficher le planificateur des collectes
              </p>
          }
        </Container>
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(Schedule);
